/*
 * // Created on 2024-02-22
 * // Created by Vitaut Tryputsin
 * //
 * // Copyright (c) 2024 OPEN CASCADE SAS
 * //
 * // This file is part of commercial software by OPEN CASCADE SAS,
 * // furnished in accordance with the terms and conditions of the contract
 * // and with the inclusion of this copyright notice.
 * // This file or any part thereof may not be provided or otherwise
 * // made available to any third party.
 * //
 * // No ownership title to the software is transferred hereby.
 * //
 * // OPEN CASCADE SAS makes no representation or warranties with respect to the
 * // performance of this software, and specifically disclaims any responsibility
 * // for any damages, special or consequential, connected with its use.
 *
 */
import { Mat4Tools } from "../../../core/geometry/mat4-tools.js";
import { Vec3Tools } from "../../../core/geometry/vec3-tools.js";
export var MoveType;
(function (MoveType) {
    MoveType[MoveType["Up"] = 0] = "Up";
    MoveType[MoveType["Down"] = 1] = "Down";
    MoveType[MoveType["Left"] = 2] = "Left";
    MoveType[MoveType["Right"] = 3] = "Right";
    MoveType[MoveType["RotateLeft"] = 4] = "RotateLeft";
    MoveType[MoveType["RotateRight"] = 5] = "RotateRight";
})(MoveType || (MoveType = {}));
/**
 * Move controller.
 * It move the object in the scene.
 * Based on the camera orientation.
 */
export class MoveController {
    constructor(theObject, theCamera) {
        this._myObject = theObject;
        this._myCamera = theCamera;
    }
    /**
     * Move object.
     * @param theType move type
     * @param theStep move step
     */
    move(theType, theStep) {
        let anAngle = 0;
        let anOffset = 0;
        switch (theType) {
            case MoveType.Up:
                anOffset = theStep;
                break;
            case MoveType.Down:
                anOffset = -theStep;
                break;
            case MoveType.Right:
                anOffset = theStep;
                break;
            case MoveType.Left:
                anOffset = -theStep;
                break;
            case MoveType.RotateRight:
                anAngle = theStep;
                break;
            case MoveType.RotateLeft:
                anAngle = -theStep;
                break;
        }
        const anUp = this._myCamera.cameraParameters.up;
        const aDir = this._myCamera.cameraParameters.direction;
        const aRight = Vec3Tools.normalize(Vec3Tools.cross(aDir, anUp));
        let aNewPos = { x: 0, y: 0, z: 0 };
        if (theType === MoveType.Left || theType === MoveType.Right) {
            aNewPos = Vec3Tools.multiply(aRight, anOffset);
        }
        if (theType === MoveType.Up || theType === MoveType.Down) {
            aNewPos = Vec3Tools.multiply(anUp, anOffset);
        }
        this._myObject.position = Vec3Tools.add(this._myObject.position, aNewPos);
        const aRotation = Mat4Tools.buildRotationMatrix(this._myObject.position, aDir, anAngle);
        const anOldTransform = this._myObject.transformation;
        this._myObject.transformation = Mat4Tools.multiply(aRotation, anOldTransform);
    }
}
